export enum LearnerJobStatusEnum {
  Active = 1,
  WaitList = 2,
  OnHold = 3,
  Complete = 4,
}
